import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Button from '../../../components/form/Button';
import { styles } from '../index';
import { getForwardingOrpOptions } from '../CroActions';

class ForwardingClarifyingDialog extends Component {
  state = {
    workingPositionId: '',
    selectedOrp: null,
    orps: [],
    loadingOrps: false,
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      this.setState({ workingPositionId: '', selectedOrp: null, orps: [], loadingOrps: true });
      this.loadOrps();
    }
  }

  loadOrps = async () => {
    const { startUrl, officialId, dispatch } = this.props;
    if (!officialId || !startUrl) {
      this.setState({ loadingOrps: false });
      return;
    }
    try {
      const data = await getForwardingOrpOptions(startUrl, officialId, dispatch);
      this.setState({
        orps: data.orps || [],
        selectedOrp: data.defaultOrp || null,
        loadingOrps: false,
      });
    } catch (e) {
      this.setState({ loadingOrps: false });
    }
  };

  formatDate = (d) => {
    if (!d) return '';
    const date = new Date(d);
    if (isNaN(date.getTime())) return d;
    return `${date.getDate()}. ${date.getMonth() + 1}. ${date.getFullYear()}`;
  };

  formatWpLabel = (wp) => {
    const name = wp.workingPosition?.name || wp.name || wp.id;
    const org = wp.organization || wp.ovmName || '';
    const from = this.formatDate(wp.dateOfStart || wp.start);
    const to = this.formatDate(wp.dateOfEnd || wp.end);
    const dates = from || to ? `${from} - ${to || '…'}` : '';
    return [name, org, dates].filter(Boolean).join(' ');
  };

  handleConfirm = () => {
    const { workingPositionId, selectedOrp } = this.state;
    if (!workingPositionId || !selectedOrp) return;
    this.props.onConfirm({ workingPositionId, administrativeAuthorityId: selectedOrp.id });
  };

  render() {
    const { open, reason, workingPositions = [], onCancel } = this.props;
    const { workingPositionId, selectedOrp, orps, loadingOrps } = this.state;
    const canConfirm = !!workingPositionId && !!selectedOrp;

    const selectedWp = workingPositions.find((wp) => wp.id === workingPositionId) || null;

    return (
      <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
        <DialogTitle>
          K postoupení{reason ? ` – ${reason.name}` : ''}
        </DialogTitle>
        <DialogContent>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16, marginTop: 8 }}>
            <Autocomplete
              options={workingPositions}
              getOptionLabel={(wp) => this.formatWpLabel(wp)}
              value={selectedWp}
              onChange={(_, wp) => this.setState({ workingPositionId: wp ? wp.id : '' })}
              isOptionEqualToValue={(opt, val) => opt.id === val.id}
              renderInput={(params) => (
                <TextField {...params} label="Funkce" variant="standard" />
              )}
              fullWidth
            />

            <Autocomplete
              options={orps}
              getOptionLabel={(o) => o?.name ?? ''}
              isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
              value={selectedOrp}
              onChange={(_, val) => this.setState({ selectedOrp: val })}
              disabled={loadingOrps}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Kam postoupit (ORP)"
                  variant="standard"
                  helperText={loadingOrps ? 'Načítám seznam ORP…' : ''}
                />
              )}
              fullWidth
            />
          </div>
        </DialogContent>
        <DialogActions style={{ gap: 12, padding: '8px 24px 16px' }}>
          <Button
            type="button"
            style={styles.buttons}
            label="Zpět"
            onClick={onCancel}
          />
          <Button
            type="button"
            style={styles.buttons}
            label="Generovat dokument"
            disabled={!canConfirm}
            onClick={this.handleConfirm}
          />
        </DialogActions>
      </Dialog>
    );
  }
}

export default connect()(ForwardingClarifyingDialog);
